var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { lg: "7", order: "2", "order-lg": "1" } },
        [
          _vm.type == "museum"
            ? _c("ul", [
                _c("li", [_vm._v("100% cotton fibre.")]),
                _c("li", [_vm._v("Free from lignin and sulphur.")]),
                _c("li", [_vm._v("OBA-free (Optical Brightening Agents).")]),
                _c("li", [
                  _vm._v("Lightfast, Blue Wool Scale reading of 5 minimum."),
                ]),
                _c("li", [
                  _vm._v(
                    "Passes the Silver Tarnish Test and Photographic Activity Test."
                  ),
                ]),
                _c("li", [
                  _vm._v(
                    "EVA polymer adhesive, contains no plasticisers, pH7.0."
                  ),
                ]),
                _c("li", [
                  _vm._v("Museum Cream: Buffered with calcium carbonate"),
                ]),
                _c("li", [_vm._v("TG Off White: unbuffered")]),
                _c("li", [
                  _vm._v("Surface sized (pure non-ionic farina starch)."),
                ]),
              ])
            : _vm._e(),
          _c(
            "b-row",
            { staticClass: "mb-4" },
            [
              _c("b-col", { attrs: { sm: "3" } }),
              _c(
                "b-col",
                { staticClass: "text-center" },
                [
                  _c("unit-selector", {
                    attrs: { size: "lg" },
                    model: {
                      value: _vm.unit,
                      callback: function ($$v) {
                        _vm.unit = $$v
                      },
                      expression: "unit",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "mb-4", attrs: { "align-v": "center" } },
            [
              _c("b-col", { attrs: { sm: "3", lg: "12", xl: "3" } }, [
                _c(
                  "h5",
                  {
                    staticClass:
                      "mb-2 mb-sm-0 mb-lg-2 mb-xl-0 text-sm-right text-lg-left text-xl-right",
                  },
                  [_vm._v("External Size:")]
                ),
              ]),
              _c(
                "b-col",
                [
                  _c("size-input", {
                    attrs: {
                      size: "lg",
                      unit: _vm.unit,
                      valid: _vm.validate.external,
                    },
                    model: {
                      value: _vm.externalSize,
                      callback: function ($$v) {
                        _vm.externalSize = $$v
                      },
                      expression: "externalSize",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "mb-4", attrs: { "align-v": "center" } },
            [
              _c("b-col", { attrs: { sm: "3", lg: "12", xl: "3" } }, [
                _c(
                  "h5",
                  {
                    staticClass:
                      "mb-2 mb-sm-0 mb-lg-2 mb-xl-0 text-sm-right text-lg-left text-xl-right",
                  },
                  [_vm._v("Aperture Size:")]
                ),
              ]),
              _c(
                "b-col",
                [
                  _c("size-input", {
                    attrs: {
                      size: "lg",
                      unit: _vm.unit,
                      valid: _vm.validate.aperture,
                    },
                    model: {
                      value: _vm.apertureSize,
                      callback: function ($$v) {
                        _vm.apertureSize = $$v
                      },
                      expression: "apertureSize",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "mb-4", attrs: { "align-v": "center" } },
            [
              _c("b-col", { attrs: { sm: "3", lg: "12", xl: "3" } }, [
                _c(
                  "h5",
                  {
                    staticClass:
                      "mb-2 mb-sm-0 mb-lg-2 mb-xl-0 text-sm-right text-lg-left text-xl-right",
                  },
                  [_vm._v("Borders:")]
                ),
              ]),
              _c(
                "b-col",
                [
                  _c("size-input", {
                    attrs: {
                      size: "lg",
                      unit: _vm.unit,
                      "show-x": false,
                      valid: _vm.validate.borders,
                      readonly: "",
                    },
                    model: {
                      value: _vm.borderSizes,
                      callback: function ($$v) {
                        _vm.borderSizes = $$v
                      },
                      expression: "borderSizes",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { sm: "3", lg: "12", xl: "3" } }, [
                _c(
                  "h5",
                  { staticClass: "text-sm-right text-lg-left text-xl-right" },
                  [_vm._v("Colour:")]
                ),
              ]),
              _c(
                "b-col",
                [
                  _c("mountboard-selector", {
                    attrs: {
                      mountboards: _vm.mountboards,
                      loading: _vm.loading,
                    },
                    model: {
                      value: _vm.mountboard,
                      callback: function ($$v) {
                        _vm.mountboard = $$v
                      },
                      expression: "mountboard",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("hr"),
          _c("p", { staticClass: "mb-0" }, [
            _vm._v(
              "Please note that the photo mount will be cut to the exact dimensions you enter."
            ),
          ]),
          _c("p", { staticClass: "mb-0" }, [
            _vm._v(
              "This means that if you enter the exact size of your artwork, it will fall through the aperture."
            ),
          ]),
          _c("p", { staticClass: "mb-0" }, [
            _vm._v(
              'We recommend subtracting 3mm (1/8") from each internal side to ensure your artwork is secure behind the mountboard.'
            ),
          ]),
          _c("hr"),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6", order: "2", "order-md": "1" } },
                [
                  _c(
                    "b-card",
                    { staticClass: "mb-3" },
                    [
                      _c("h4", { staticClass: "card-title" }, [
                        _vm._v("Volume Discounts"),
                      ]),
                      _c("p", { staticClass: "card-text" }, [
                        _vm._v("The more you buy, the more you save!"),
                      ]),
                      _c("discounts-breakdown", {
                        staticClass: "mb-0",
                        attrs: {
                          loading: _vm.loadingDiscounts,
                          discounts: _vm.discounts,
                          "item-type": "Mount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6", order: "1", "order-md": "2" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Quantity:",
                        "label-cols-md": "6",
                        "label-align-md": "right",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          state: _vm.validate.quantity,
                          number: "",
                          min: "1",
                          step: "1",
                          type: "number",
                        },
                        model: {
                          value: _vm.quantity,
                          callback: function ($$v) {
                            _vm.quantity = $$v
                          },
                          expression: "quantity",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-cols-md": "6",
                        "label-align-md": "right",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _vm._v("Undermount"),
                              _c("br"),
                              _c("small", [
                                _c("em", [
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "b-modal",
                                          rawName: "v-b-modal.undermount",
                                          modifiers: { undermount: true },
                                        },
                                      ],
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                        },
                                      },
                                    },
                                    [_vm._v("What is an Undermount?")]
                                  ),
                                ]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: { size: "lg" },
                          model: {
                            value: _vm.incUndermount,
                            callback: function ($$v) {
                              _vm.incUndermount = $$v
                            },
                            expression: "incUndermount",
                          },
                        },
                        [_vm._v("(£" + _vm._s(_vm.undermountPrice) + ")")]
                      ),
                    ],
                    1
                  ),
                  _c("mount-order-breakdown", {
                    attrs: {
                      "is-valid": _vm.isValid,
                      "external-size": _vm.externalSize,
                      "aperture-size": _vm.apertureSize,
                      "inc-undermount": _vm.incUndermount,
                      board: _vm.mountboard,
                      "undermount-price": _vm.withUndermountPricing.unit_price,
                      "mount-price": _vm.mountPricing.unit_price,
                      quantity: _vm.quantity,
                    },
                  }),
                  _c(
                    "b-alert",
                    {
                      attrs: {
                        show: _vm.warnings.length > 0,
                        variant: "warning",
                      },
                    },
                    [
                      _c("p", { staticClass: "mb-2" }, [
                        _c("strong", [
                          _vm._v(
                            "Please note the following warnings before continuing:"
                          ),
                        ]),
                      ]),
                      _vm._l(_vm.warnings, function (string) {
                        return _c("p", {
                          staticClass: "mb-1",
                          domProps: { innerHTML: _vm._s(string) },
                        })
                      }),
                    ],
                    2
                  ),
                  _c(
                    "b-alert",
                    {
                      attrs: {
                        show: _vm.validationStrings.length > 0,
                        variant: "danger",
                      },
                    },
                    [
                      _c("p", { staticClass: "mb-2" }, [
                        _c("strong", [
                          _vm._v(
                            "Sorry, this product is currently unavailable for the following reasons:"
                          ),
                        ]),
                      ]),
                      _vm._l(_vm.validationStrings, function (string) {
                        return _c("p", {
                          staticClass: "mb-1",
                          domProps: { innerHTML: _vm._s(string) },
                        })
                      }),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "text-right mb-3" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            size: "lg",
                            variant: _vm.cartButtonState,
                            disabled: _vm.isAddToCartDisabled,
                          },
                          on: { click: _vm.addToCart },
                        },
                        [
                          _c("span", { staticClass: "material-icons mr-1" }, [
                            _vm._v("shopping_cart"),
                          ]),
                          _vm._v(
                            "Add to Cart (£" + _vm._s(_vm.totalPrice) + ")"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-col", { attrs: { lg: "5", order: "1", "order-lg": "2" } }, [
        _c(
          "div",
          { staticClass: "sticky-top" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { staticClass: "text-center mb-5 mt-3 viz" },
                  [
                    _c("mount-visualisation", {
                      attrs: {
                        id: "mount-visualisation",
                        board: _vm.mountboard,
                        "external-size": _vm.externalSize,
                        "aperture-size": _vm.apertureSize,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-row",
              { attrs: { "align-h": "center" } },
              [
                _c(
                  "b-col",
                  { staticClass: "text-center", attrs: { sm: "8" } },
                  [
                    _c(
                      "picture",
                      [
                        _c("source", {
                          attrs: { srcset: _vm.ljLogoWebp, type: "image/webp" },
                        }),
                        _c("source", {
                          attrs: { srcset: _vm.ljLogo, type: "image/jpeg" },
                        }),
                        _c("b-img", {
                          staticClass: "mb-4",
                          attrs: {
                            src: _vm.ljLogo,
                            fluid: "",
                            alt: "Larson Juhl Mountboard",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "p",
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("info"),
                        ]),
                        _vm._v(" Not sure what to order? "),
                        _c("br"),
                        _vm._v("View our "),
                        _c(
                          "router-link",
                          { attrs: { to: { name: "buying-guide" } } },
                          [_vm._v("Picture Mount Buying Guide")]
                        ),
                        _vm._v("."),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            id: "undermount",
            title: "What is an Undermount?",
            "ok-only": "",
          },
        },
        [
          _vm.type == "standard"
            ? _c("div", { staticClass: "std-undermount" }, [
                _c("p", [
                  _vm._v("Whitecore 1400 micron (1.4mm) thick mountboard."),
                ]),
                _c("p", [
                  _vm._v(
                    "This mountboard is suitable for mounting your artwork onto. The purpose is to be used as a barrier between the artwork and the backing board, and prevents the transfer of damaging chemicals from non-certified backing boards onto artwork substrates."
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    "One face of the undermount board is Snow White (#8001), and the other face is Minuet (#8627)."
                  ),
                ]),
              ])
            : _c("div", { staticClass: "mus-undermount" }, [
                _c("p", [
                  _vm._v(
                    "Off White Museum CottonCore 1100 micron (1.1mm) thick mountboard."
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    "This mountboard is suitable for mounting your artwork onto. The purpose is to be used as a barrier between the artwork and the backing board, and prevents the transfer of damaging chemicals from non-certified backing boards onto artwork substrates."
                  ),
                ]),
              ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }